const identityServerErrorCodes = {
    noPermissionToLogin: '1028',
    signinLinkHasExpired: '1029'
};

export default identityServerErrorCodes;
